import { Message } from "aderant-conflicts-models";

export const Messages = {
    HIT_SHARED_HEADER: new Message("HIT_SHARED_HEADER", "Hits Shared to Reviewers"),
    HIT_SHARED_SUBHEADER: new Message(
        "HIT_SHARED_SUBHEADER",
        "Hits with the selected statuses will be shared to Reviewers. If a hit has a status that has not been selected, it will not be shared to Reviewers."
    ),
    STATUS_CONTROL_HEADER: new Message("STATUS_CONTROL_HEADER", "Reviewer Hit Status Control"),
    STATUS_CONTROL_SUBHEADER: new Message(
        "STATUS_CONTROL_SUBHEADER",
        "Choose which statuses will be accessible to Reviewers. If a status is selected, Reviewers can apply it to the hits they have been shared. If a status is not selected, it will not be visible to Reviewers."
    )
};
